// Product media lightbox (snippets/product-media-modal.liquid). Opens on the clicked media and
// starts videos straight away when they were opened from a play button.
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const id = this.openedBy && this.openedBy.getAttribute('data-media-id');
        const items = this.querySelectorAll('[data-media-id]');
        items.forEach((el) => el.classList.toggle('active', el.getAttribute('data-media-id') === id));
        const active = id ? this.querySelector(`[data-media-id="${id}"]`) : items[0];
        if (!active) return;
        active.scrollIntoView({ block: 'center' });
        const container = this.querySelector('[role="document"]');
        if (container && active.width) container.scrollLeft = (active.width - container.clientWidth) / 2;
        if (active.nodeName === 'DEFERRED-MEDIA' && active.loadContent) active.loadContent(false);
      }
    }
  );
}
